import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'gatsby';
import down_arrow_blue from '../../images/down_arrow_blue.svg';
import down_arrow_white from '../../images/down_arrow_white.svg';
import ArrowForwardIcon from '../../images/hx_arrow-narrow-right-filled.svg';

import theme from '../../themes/theme';

const DropdownIcon = styled.img`
    width: 16px;
    height: 16px;
    margin-left: 6px;
    color: rgba(37, 41, 99, 1);
    padding-top: 2px;
    transform: rotate(0deg);
`;

const DropDownBox = styled.div`
    display: none;
    grid-template-rows: ${({ heading }) =>
        heading === 'Resources' ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)'};
    grid-auto-flow: column;
    gap: 12px 24px;
    position: absolute;
    left: 0px;
    top: 100%;
    width: max-content;
    transition: top 0.3s ease-out;
    border-radius: 16px;
    border: 1px solid #eff0f6;
    overflow: hidden;
    box-shadow: 0px 9px 26px 0px #170f490d, 0px 10px 14px 0px #4a3aff03;
    background: #fff;
    padding: 12px;

    @media screen and (max-width: 912px) {
        position: static;
        width: 100%;
        justify-content: center;
        box-shadow: none;
        border-radius: 0;
        border: none;
        margin-top: 4px;
    }

    &:hover {
        &:not(:hover) {
            display: none;
        }
    }
`;

const Container = styled.div`
    display: inline-flex;
    position: relative;
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
    color: ${({ color }) => color};
    padding-bottom: 8px;
    margin: auto 12px;
    cursor: pointer;

    &:hover ${DropDownBox} {
        display: grid;
    }

    &:hover ${DropdownIcon} {
        transform: rotate(180deg);
    }

    @media screen and (max-width: 912px) {
        text-align: center;
        padding: 0;
    }
`;

const LinkIconWrapper = styled.div`
    padding: 11px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0px 4px 20px 0px #170f4914;
`;

const LinkIcon = styled.img`
    height: 30px;
    width: 30px;
`;

const ArrowIcon = styled.img`
    display: none;
    width: 18px;
    height: 18px;
`;

const LinkContainer = styled(Link)`
    display: flex;
    flex-direction: row;
    gap: 18px;
    align-items: center;
    text-decoration: none;
    min-width: 260px;
    max-width: 320px;
    padding: 12px;

    &:hover {
        transition: padding 4s ease-in-out;
        border-radius: 12px;
        background-color: #e3eeff;
        transition: 0.3ms;
    }

    &:hover ${ArrowIcon} {
        display: block;
    }

    &:hover ${LinkIcon} {
        filter: invert(12%) sepia(30%) saturate(7468%) hue-rotate(229deg) brightness(81%)
            contrast(106%);
    }
`;

const SubPageDesc = styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #4b5563;
    margin-top: 8px;
`;

const SubPageLink = styled.p`
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: #262626;
    display: flex;
    align-items: flex-start;
    width: 100%;
    justify-content: space-between;
    gap: 12px;

    @media screen and (max-width: 912px) {
        text-align: center;
        margin: 0 auto;
    }
`;

function SubMenu({ name, data, linkColor, linkHoverIcon }) {
    return (
        <Container color={linkColor} linkHoverIcon={linkHoverIcon}>
            {name}
            <DropdownIcon
                src={linkColor === theme.colors.white ? down_arrow_white : down_arrow_blue}
                alt="Down arrow"
            />
            <DropDownBox heading={name}>
                {data.map((item) => (
                    <LinkContainer key={item.id} to={item.link.route} {...item.link}>
                        <LinkIconWrapper>
                            <LinkIcon src={item.icon} alt={item.title} />
                        </LinkIconWrapper>
                        <div style={{ width: '100%' }}>
                            <SubPageLink>
                                <span>{item.title}</span>{' '}
                                <ArrowIcon src={ArrowForwardIcon} alt="icon" />
                            </SubPageLink>
                            <SubPageDesc>{item.desc}</SubPageDesc>
                        </div>
                    </LinkContainer>
                ))}
            </DropDownBox>
        </Container>
    );
}

SubMenu.propTypes = {
    name: PropTypes.string,
    data: PropTypes.array,
    linkColor: PropTypes.string,
    linkHoverIcon: PropTypes.string,
};

export default SubMenu;
